var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',{staticClass:"pointer-on-hover",on:{"click":function($event){_vm.status = _vm.status == 'not_started' ? '' : 'not_started'; _vm.$emit('input', _vm.status)}}},[_c('div',{staticClass:"pl-2 btn_status",class:{ 
          'bg-gray-dark': _vm.status == 'not_started',
          'font-12' : _vm.isMobile,
          'py-3': !_vm.isMobile,
          'py-1': _vm.isMobile,
        }},[_vm._v("\n        A iniciar  \n      ")]),_vm._v(" "),_c('v-progress-linear',{attrs:{"value":"0"}})],1),_vm._v(" "),_c('v-col',{staticClass:"pointer-on-hover",on:{"click":function($event){_vm.status = _vm.status == 'is_started' ? '' : 'is_started'; _vm.$emit('input', _vm.status)}}},[_c('div',{staticClass:"pl-2 btn_status",class:{ 
          'bg-gray-dark': _vm.status == 'is_started',
          'font-12' : _vm.isMobile,
          'py-3': !_vm.isMobile,
          'py-1': _vm.isMobile,
        }},[_vm._v("\n        Em andamento\n      ")]),_vm._v(" "),_c('v-progress-linear',{attrs:{"value":"50"}})],1),_vm._v(" "),_c('v-col',{staticClass:"pointer-on-hover",on:{"click":function($event){_vm.status = _vm.status == 'finished' ? '' : 'finished'; _vm.$emit('input', _vm.status)}}},[_c('div',{staticClass:"pl-2 btn_status",class:{ 
          'bg-gray-dark': _vm.status == 'finished',
          'font-12' : _vm.isMobile,
          'py-3': !_vm.isMobile,
          'py-1': _vm.isMobile,
        }},[_vm._v("\n        Finalizado\n      ")]),_vm._v(" "),_c('v-progress-linear',{attrs:{"value":"100"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }